import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {useIsPlatform} from '@github-ui/use-is-platform'
import {useNavigate} from '@github-ui/use-navigate'
import {useCallback} from 'react'

import type {MilestoneNode} from './repository-milestone-index-page-query-types'

// RELAY-CLEANUP(MilestoneList): RelayCompat widens nullable fields so the still-Relay parent
// data is assignable. Remove when MilestoneList leaves Relay.
export type MilestoneRowTitleFragment = RelayCompat<Pick<MilestoneNode, 'title' | 'url'>>

type MilestoneRowProps = {
  milestone: MilestoneRowTitleFragment
}

export function MilestoneRowTitle({milestone}: MilestoneRowProps) {
  const href = milestone.url
  const isMac = useIsPlatform(['mac'])
  const navigate = useNavigate()
  const onClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
      const isMetaKey = isMac ? event.metaKey : event.ctrlKey
      if (isMetaKey) {
        return
      }

      event.preventDefault()
      const url = new URL(href, window.location.origin)
      const path = url.pathname
      navigate(path)
    },
    [href, isMac, navigate],
  )

  return <ListItemTitle value={milestone.title} href={milestone.url} onClick={onClick} />
}
